import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from 'react-router-dom';

import { authLoader, publicLoader } from '../authentication/authLoader';
import { queryClient } from '../lib/react-query';
import ErrorPage from './routes/error-page';
import Root from './routes/root';
import { studioRoute } from './routes/studio/route';

// Created on first render, not at import time: createBrowserRouter() calls
// .initialize() straight away, which runs the matched route's loaders. At import time
// that beats msw's worker.start(), so the mock handlers would miss the first requests.
// Memoised outside React so StrictMode's double render reuses the same router.
let cachedRouter: ReturnType<typeof createBrowserRouter> | undefined;

const createRouter = () =>
  createBrowserRouter([
    {
      path: '/',
      id: 'root',
      element: <Root />,
      loader: authLoader,
      errorElement: <ErrorPage />,
      children: [
        {
          index: true,
          loader: () => redirect('/studios'),
        },
        {
          path: 'login',
          loader: publicLoader,
          lazy: () => import('@/app/routes/auth/login'),
          children: [
            {
              path: 'login-form',
              lazy: () => import('@/app/routes/auth/login-form'),
            },
            {
              path: 'sso-microsoft',
              lazy: () => import('@/app/routes/auth/sso-microsoft'),
            },
          ],
        },
        {
          path: 'logout',
          lazy: () => import('@/app/routes/auth/logout'),
        },
        {
          path: 'studios',
          lazy: () => import('@/app/routes/studio/list'),
        },
        {
          path: 'account',
          lazy: () => import('@/app/routes/account'),
        },
        // URLs from before the Studio level (#469) — bookmarks, shared links.
        { path: 'game/*', loader: () => redirect('/studios') },
        studioRoute(queryClient),
      ],
    },
  ]);

export const AppRouter = () => {
  cachedRouter ??= createRouter();

  return <RouterProvider router={cachedRouter} />;
};
